module.exports = __webpack_public_path__ + "static/media/logo.52e7d5ec.svg";